import { Injectable } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { BehaviorSubject, fromEvent, map } from "rxjs";

@Injectable({
  providedIn: "root",
})
@UntilDestroy()
export class WindowService {
  windowSize$: BehaviorSubject<{ width: number }>;
  constructor() {
    this.windowSize$ = new BehaviorSubject({
      width: window.innerWidth,
    });

    fromEvent(window, "resize")
      .pipe(
        untilDestroyed(this),
        map((event: Event) => {
          return {
            width: window.innerWidth,
          };
        })
      )
      .subscribe(this.windowSize$);
  }
}
